import {Pipe, PipeTransform} from "@angular/core"
import { CartitemsService } from '../providers/cartitems.service';

@Pipe({name: 'orderstatusfilter'})
export class OrderStatusPipe implements PipeTransform {

  constructor(private cartitems : CartitemsService){}
  
    transform(items: any[], filter: any): any {
        if (!items || !filter) {
            return items;
        }
        let status = this.cartitems.orderstatuses[filter];
        return items.filter(item => status === 0 || item.status === status);
       // return items.filter(item => status === 0 || item.status === status || (status === 3 && item.status === 2));
        
    }

}


// WEBPACK FOOTER //
// ./src/app/providers/ordersstatuspipe.ts